import { useRouteShare } from 'routes';

import { IconButton } from 'components/Blocks';
import { LinkIcon } from 'components/Icons';

import { projectTabs } from 'pages/Projects/ProjectProfile/tabs';

import { useTaskModal } from '../context.taskModal';

export function TaskLink() {
  const { task } = useTaskModal();
  const copyTaskLink = useRouteShare('projectProfile');

  return (
    <IconButton
      tooltipContent="Copy Link to Task"
      onClick={() =>
        copyTaskLink({
          projectId: task.projectId,
          taskId: task.id,
          tab: projectTabs.execution,
        })
      }
    >
      <LinkIcon />
    </IconButton>
  );
}
